import getLocal from '@/app/utils/getLocal';
import { TableCheckIcon, TableNormalIcon, TablePlusIcon, TableTipsIcon } from '@/components/EcoCredits/Svg';
import { Tooltip } from 'antd';
import EditorLink from 'lowcode/components/EditorLink';
import { useEcoStore } from 'lowcode/utils/context/ecocredits';
import { getLang } from 'lowcomp/plugins/member/utils';
import { FC, ReactNode } from 'react';
import { TextLang } from '../../TextLang';
import styled from './index.module.scss';
const TableEmptyIcon = () => (
    <svg width="12" height="4" viewBox="0 0 12 4" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="12" height="4" fill="#D9D9D9" />
    </svg>
);

export type tableItem = {
    icon: () => ReactNode;
    text: string;
    tips?: string;
    linkText?: string;
    key?: string;
    onlyPlus?: boolean;
};

interface IBenefitsTableProps {
    list: tableItem[];
    handleTools: (key?: string) => void;
    isLogin: boolean;
}

const BenefitsTable: FC<IBenefitsTableProps> = ({ list, handleTools, isLogin }) => {
    const { locale } = getLocal();
    const t = getLang(TextLang, locale);
    const { rewardUserLevel } = useEcoStore();

    return (
        <div className={styled.BenefitsTable}>
            <div className="table-container">
                <ul className="table-header">
                    <li>
                        <span>{t('ecoflowbenefits_tab_benefits')}</span>
                    </li>
                    <li>
                        <TablePlusIcon />
                        <span>{rewardUserLevel?.plusName}</span>
                    </li>
                    <li>
                        <TableNormalIcon />
                        <span>{rewardUserLevel?.normalName}</span>
                    </li>
                </ul>
                <div>
                    {list
                        .filter((item) => (!isLogin ? !item.key : true)) // 未登录的时候 三个存在按钮的均不显示
                        .map((item, index) => (
                            <ul className="table-body" key={item.text + index} style={{ background: index % 2 !== 1 ? '#fff' : '#FAF3E3' }}>
                                <li>
                                    {item.icon && <span className="table-icon">{item.icon()}</span>}
                                    <span className="table-text">
                                        {item.text}
                                        {item.tips && (
                                            <Tooltip
                                                placement="bottom"
                                                title={<div style={{ whiteSpace: 'pre-line' }} dangerouslySetInnerHTML={{ __html: item.tips }} />}
                                            >
                                                <TableTipsIcon />
                                            </Tooltip>
                                        )}
                                        {item.linkText && (
                                            <EditorLink className="table-text-link" onClick={() => handleTools(item.key)}>
                                                {item.linkText}
                                            </EditorLink>
                                        )}
                                    </span>
                                </li>
                                <li>
                                    <TableCheckIcon />
                                </li>
                                <li>{item.onlyPlus ? <TableEmptyIcon /> : <TableCheckIcon />}</li>
                            </ul>
                        ))}
                </div>
            </div>
        </div>
    );
};

export default BenefitsTable;
